export const profile = {
    text1: "Le informazioni del mio account",
    text2: "Informazioni personali",
    text3: "Nome",
    text4: "Numero di documento",
    text5: "Telefono",
    text6: "Paese",
    text7: "Indirizzo email",
    text8: "Aggiorna informazioni",
    text9: "Dati di accesso",
    text10: "Password",
    text11: "Conferma password",
    text12: "Aggiorna password",

    // Corrections
    p1: "Impostazioni dell'account",
    p2: "Dati del profilo",
    p3: "Accesso e sicurezza",
    p4: "Informazioni di fatturazione",
    p5: "Indirizzo email principale",
    p6: "Qui riceverai tutte le comunicazioni da WACheckin",
    p7: "Informazioni dell'account",
    p8: "Gestisci i dati del tuo account.",
    p9: "Nome",
    p10: "Inserisci il nome completo",
    p11: "Numero di documento",
    p12: "Inserisci il numero di documento",
    p13: "Telefono",
    p14: "Inserisci il numero di telefono",
    p15: "Accesso e sicurezza",
    p16: "Aggiorna la password e proteggi il tuo account.",
    p17: "Password dell'account",
    p18: "Ultimo aggiornamento:",
    p19: "Cambia password",
    p20: "Informazioni di fatturazione",
    p21: "Gestisci i dati del tuo account.",
    p22: "Ragione sociale",
    p23: "Inserisci la ragione sociale",
    p24: "Partita IVA",
    p25: "Inserisci la partita IVA",
    p26: "Indirizzo di fatturazione",
    p27: "Inserisci l'indirizzo di fatturazione",
    p28: "Paese",
    p29: "Provincia",
    p30:'CAP',
    p31:`Nessun dato di fatturazione`,
    p32:`Le informazioni di fatturazione vengono caricate automaticamente al momento dell'abbonamento.`,
};
